export let saveSignTableLabels = [
  {
    label: '活动名称',
    value: 'name'
  },
  {
    label: '分子公司',
    value: 'branchVO.name'
  },
  {
    label: '报名开始时间',
    value: 'start_time',
    minWidth: 110
  }
  // {
  //   label: '报名截止时间',
  //   value: 'end_time',
  //   minWidth: 110
  // }
]
